module.exports = __webpack_public_path__ + "media/images/icons/crea-tus-fechas-d951ecaa8b23ee0bea32532f950c709b.svg";